var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "svg",
    {
      attrs: {
        width: "100%",
        height: "100%",
        viewBox: "0 0 47 47",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
      },
    },
    [
      _c("rect", {
        attrs: {
          width: "46",
          height: "46",
          transform: "translate(0.355469 0.398438)",
          fill: "white",
        },
      }),
      _c(
        "mask",
        {
          staticStyle: { "mask-type": "alpha" },
          attrs: {
            id: "mask0_906_9138",
            maskUnits: "userSpaceOnUse",
            x: "0",
            y: "0",
            width: "47",
            height: "47",
          },
        },
        [
          _c("rect", {
            attrs: {
              x: "0.355469",
              y: "0.398438",
              width: "46",
              height: "46",
              rx: "6",
              fill: "#C4C4C4",
            },
          }),
        ]
      ),
      _c("g", { attrs: { mask: "url(#mask0_906_9138)" } }, [
        _c("path", {
          attrs: {
            d: "M0.355469 46.3984V0.398438H46.3555V46.3984",
            fill: "#5996E4",
          },
        }),
        _c("path", {
          attrs: {
            d: "M42.5029 23.3971C42.5028 33.9716 33.9305 42.5439 23.356 42.5439C12.7814 42.5439 4.20898 33.9716 4.20898 23.397C4.20898 12.8225 12.7813 4.25008 23.3558 4.25C33.9305 4.25 42.503 12.8224 42.5029 23.3971Z",
            fill: "#2464C5",
          },
        }),
        _c("path", {
          attrs: {
            d: "M30.4263 23.3939C30.4263 27.2983 27.2611 30.4635 23.3567 30.4635L23.3567 30.4636C19.4522 30.4635 16.287 27.2983 16.2871 23.3938C16.2871 19.4894 19.4522 16.3243 23.3567 16.3242C27.2611 16.3242 30.4263 19.4894 30.4263 23.3939Z",
            fill: "#5996E4",
          },
        }),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }